export default __webpack_public_path__ + "static/media/tab-active.8d344b76.svg";